(() => {
  const root = document.getElementById('spencer-air-adjustments');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const states = [...root.querySelectorAll('video')].map(video => {
    const state = {video, visible: false};
    const load = () => {
      const source = video.querySelector('source[data-src]');
      if (source) {source.src = source.dataset.src; source.removeAttribute('data-src'); video.load();}
    };
    const play = () => {load(); video.play().catch(() => {});};
    state.sync = () => {
      if (!state.visible || document.hidden || reducedMotion.matches) video.pause();
      else play();
    };
    return state;
  });
  const posterObserver = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    const video = entry.target;
    if (video.dataset.poster) {
      video.poster = video.dataset.poster;
      delete video.dataset.poster;
    }
    posterObserver.unobserve(video);
  }), {rootMargin: '400px 0px'});
  states.forEach(state => posterObserver.observe(state.video));
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    const state = states.find(item => item.video === entry.target);
    state.visible = entry.isIntersecting && entry.intersectionRatio >= .2;
    state.sync();
  }), {threshold: [0, .2]});
  states.forEach(state => observer.observe(state.video));
  document.addEventListener('visibilitychange', () => states.forEach(state => state.sync()));
  reducedMotion.addEventListener('change', () => states.forEach(state => state.sync()));
})();
